import {
    Box,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    SelectChangeEvent,
    TextField,
} from "@mui/material";
import React, { ChangeEvent, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { axiosGet } from "../../util/axios";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import {
    changeFilteredZoneListThunk,
    initBinTypeListThunk,
    initContractListThunk,
    initDistrictListThunk,
} from "../../redux/staticInfo/thunk";
import { OpenSnackBarWithResultFail } from "../../redux/common/snackBar/thunk";
import styles from "./binform.module.css";
import {
    ChangeBinContactPersonThunk,
    ChangeBinContractIdThunk,
    ChangeBinDistrictThunk,
    ChangeBinEmailThunk,
    ChangeBinEngNameThunk,
    ChangeBinLatThunk,
    ChangeBinLonThunk,
    ChangeBinNameThunk,
    ChangeBinRemarksThunk,
    ChangeBinStatusThunk,
    ChangeBinTypeThunk,
    ChangeBincCodeThunk,
    ChangeSelectedBinZoneThunk,
    ChangeToiletNumberThunk,
} from "../../redux/BinType/thunk";
import { BinFormSelectedFrom, BinFormType } from "../../interface/form";
import { initZoneListAction } from "../../redux/staticInfo/action";
import { ZoneList } from "../../redux/staticInfo/state";

function BinForm() {
    const dispatch = useDispatch<IRootThunkDispatch>();
    const dataFetchedRef = useRef(false);
    const { selectedBinItem } = useSelector(
        (state: IRootState) => state.binListState
    );
    const { contractList, districtList, binTypeList,zoneList,filteredZoneList } = useSelector(
        (state: IRootState) => state.staticInfoState
    );

    
    useEffect(() => {
        const controller = new AbortController();
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        getBinFormStaticOption();
        return () => {
            controller.abort();
        };
    }, []);

    async function getBinFormStaticOption() {
        dispatch(OpenLoadingBarThunk(true));
           const contract = await axiosGet("/api/contract");
        const district = await axiosGet("/api/district");
        const binType = await axiosGet("/api/bin/type");
        const zone = await axiosGet("/api/contract/zone")

        if (
            contract.data.success &&
            district.data.success & binType.data.success & zone.data.success
        ) {
            dispatch(OpenLoadingBarThunk(false));
            dispatch(initContractListThunk(contract.data.contractList));
            dispatch(initDistrictListThunk(district.data.districtList));
            dispatch(initBinTypeListThunk(binType.data.binTypeList));

            if (selectedBinItem.bin_id){
                // for edit drop down list of the zone 
                const zone_list = zone.data.zoneList as ZoneList[]
                const filteredZoneList = zone_list.filter(zone=>zone.contract_id==selectedBinItem.contract_id)
                dispatch(changeFilteredZoneListThunk(filteredZoneList))
                dispatch(initZoneListAction(zone.data.zoneList))
                return 
            }
                // for new form 
                dispatch(initZoneListAction(zone.data.zoneList))
            

           
        } else {
            dispatch(OpenSnackBarWithResultFail("未能取得位置或地區表"));
        }
    }

    function handleChangeForm(
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        type: BinFormType
    ) {
        switch (type) {
            case "location_cn":
                dispatch(ChangeBinNameThunk(event.target.value));
                break;
            case "location_en":
                dispatch(ChangeBinEngNameThunk(event.target.value));
                break;
            case "email":
                dispatch(ChangeBinEmailThunk(event.target.value));
                break;
            case "contact_person":
                dispatch(ChangeBinContactPersonThunk(event.target.value));
                break;
            case "code":
                dispatch(ChangeBincCodeThunk(event.target.value));
                break;
            case "lat":
                dispatch(ChangeBinLatThunk(event.target.value));
                break;
            case "lon":
                dispatch(ChangeBinLonThunk(event.target.value));
                break;
            case "remarks":
                dispatch(ChangeBinRemarksThunk(event.target.value));
                break;
            case "toilet_number":
                dispatch(ChangeToiletNumberThunk(event.target.value));
                break;
        }
    }

    function handleChangeSelectForm(
        event: SelectChangeEvent<number | null>,
        type: BinFormSelectedFrom
    ) {
        switch (type) {
            case "contract":             

                const filteredZoneList = zoneList.filter(zone=>zone.contract_id==event.target.value)
                
                dispatch(changeFilteredZoneListThunk(filteredZoneList))

                dispatch(
                    ChangeBinContractIdThunk(event.target.value?.toString()!)
                );
                break;

            case "district":
                const selectedData = districtList.find(
                    (district) => district.district_id == event.target.value
                );
                if (selectedData) {
                    dispatch(ChangeBinDistrictThunk(selectedData));
                }
                break;
            case "binType":
                dispatch(ChangeBinTypeThunk(event.target.value?.toString()!));
                break;

            case "status":
                dispatch(ChangeBinStatusThunk(event.target.value?.toString()!));
                break;

            case "zone":

                dispatch(ChangeSelectedBinZoneThunk(event.target.value! as number))
                break;

        }
    }

    return (
        <Grid>
            <Box
                component="form"
                sx={{
                    "& .MuiTextField-root": { m: 1, width: "100%" },
                }}
                noValidate
                autoComplete="off"
            >
                <Grid className={styles.outerContainer}>
                    <TextField
                        id="outlined-required"
                        placeholder="請輸入廁所名稱"
                        fullWidth
                        value={selectedBinItem?.location_cn}
                        label="廁所名稱"
                        required
                        onChange={(e) => handleChangeForm(e, "location_cn")}
                    />

                </Grid>

                <Grid className={styles.outerContainer}>

                    <TextField
                        id="outlined-required"
                        placeholder="請輸入參考編號"
                        fullWidth
                        value={selectedBinItem?.code}
                        label="參考編號"
                        required
                        onChange={(e) => handleChangeForm(e, "code")}
                    />
                    <TextField
                        id="outlined-required"
                        placeholder="請輸入廁所編號"
                        fullWidth
                        value={selectedBinItem?.toilet_number}
                        label="廁所編號"
                        required
                        onChange={(e) => handleChangeForm(e, "toilet_number")}
                    />

                    {/* <TextField
                        id="outlined-required"
                        placeholder="請輸入回收桶lat"
                        fullWidth
                        value={selectedBinItem?.lat}
                        type="number"
                        label="緯度 latitude"
                        required
                        onChange={(e) => handleChangeForm(e, "lat")}
                    />
                    <TextField
                        id="outlined-required"
                        placeholder="lon"
                        fullWidth
                        value={selectedBinItem?.lon}
                        type="number"
                        label="緯度 longitude"
                        required
                        onChange={(e) => handleChangeForm(e, "lon")}
                    /> */}
                </Grid>

                <Grid className={styles.outerContainer}>
                    {/* <FormControl
                        fullWidth
                        className={styles.selectOuterContainer}
                    >
                        <InputLabel id="demo-simple-select-label">
                            地區*
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedBinItem?.district_id}
                            label="地區"
                            required
                            onChange={(e) =>
                                handleChangeSelectForm(e, "district")
                            }
                        >
                            {districtList.map((distict, index) => (
                                <MenuItem
                                    value={distict.district_id}
                                    key={`district-${index}`}
                                >
                                    {distict.district_cn}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl> */}

                    <FormControl
                        fullWidth
                        className={styles.selectOuterContainer}
                    >
                        <InputLabel id="demo-simple-select-label">
                            廁所類型*
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedBinItem?.bin_type_id}
                            label="地區"
                            required
                            onChange={(e) =>
                                handleChangeSelectForm(e, "binType")
                            }
                        >
                            {binTypeList ? (
                                binTypeList.map((type, index) => (
                                    <MenuItem
                                        value={type.bin_type_id?.toString()}
                                        key={`district-${index}`}
                                    >
                                        {type.bin_type}
                                    </MenuItem>
                                ))
                            ) : (
                                <></>
                            )}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid className={styles.outerContainer}>
                    <FormControl
                        fullWidth
                        className={styles.selectOuterContainer}
                    >
                        <FormLabel id="contract-label">合約*</FormLabel>

                         <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedBinItem?.contract_id}
                            label="合約編號"
                            required
                            onChange={(e) =>
                                handleChangeSelectForm(e, 'contract')
                            }
                        >
                            {contractList.map((contract, index) => (
                                <MenuItem
                                    value={contract.contract_id}
                                    key={`district-${index}`}
                                >
                                    {contract.contract}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                     <FormControl
                        fullWidth
                        className={styles.selectOuterContainer}
                    >
                        <FormLabel id="contract-label">區份</FormLabel>

                         <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedBinItem?.zone_id}
                            label="區份"
                            required
                            onChange={(e) =>
                                handleChangeSelectForm(e, "zone")
                            }
                        >
                            {filteredZoneList.map((zone) => (
                                <MenuItem
                                    value={zone.zone_id}
                                    key={`zone-${zone.zone_id}`}
                                >
                                    {zone.zone_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        fullWidth
                        className={styles.selectOuterContainer}
                    >
                        <FormLabel id="contract-label">目前狀況</FormLabel>

                        <RadioGroup
                            row
                            aria-labelledby="contract-label"
                            name="row-radio-buttons-group"
                            value={selectedBinItem?.status}
                            onChange={(e) =>
                                handleChangeSelectForm(e, "status")
                            }
                        >
                            <FormControlLabel
                                value="0"
                                control={<Radio />}
                                label="已關閉"
                                key={`contract-${0}`}
                            />

                            <FormControlLabel
                                value="1"
                                control={<Radio />}
                                label="已生效"
                                key={`contract-${1}`}
                            />
                        </RadioGroup>
                    </FormControl>

                    <TextField
                        id="outlined-required"
                        placeholder="備註"
                        fullWidth
                        value={selectedBinItem?.remarks}
                        label="備註"
                        onChange={(e) => handleChangeForm(e, "remarks")}
                    />
                </Grid>

            
            </Box>
        </Grid>
    );
}

export default BinForm;
